import React from 'react'
import '../../assets/styles/messages.css'

export default class Loader extends React.Component {    
    
render(){   
  return (                
         <div className="loader-overlay">
         <div className="loader-wrapper">
         <div className="loader-container">
            <div className="loader">&nbsp;</div>
            <div className="text color-a f6">רק רגע, בבקשה... <span className="sr-only">מבצע טעינת נתונים</span></div>
         </div>
         </div>
         </div>     
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/app/Loader.jsx